import {
  NAVIGATION_TO_LANDING_PAGE,
  NAVIGATION_TO_STEP_1,
  NAVIGATION_TO_STEP_2,
} from '../../actions/page';
import {
  RECEIVE_IS_LOADING_REFUND_ESTIMATION,
  RECEIVE_REFUND_ESTIMATION,
  SELECT_REFUND_OPTION,
  RECEIVE_REFUND_ELIGIBILITY,
} from '../../actions/refunds';

export const initialState = {
  estimate: {},
  itemizationsByType: {},
  selectedType: '',
  refundEligibility: true,
  isLoading: false,
};

export default (
  state = initialState,
  {
    type,
    data: { isLoading, estimate, itemizationsByType, selectedType, refundEligibility } = {},
  } = {},
) => {
  switch (type) {
    case RECEIVE_IS_LOADING_REFUND_ESTIMATION:
      return {
        ...state,
        isLoading,
      };

    case RECEIVE_REFUND_ESTIMATION:
      return {
        ...state,
        estimate,
        itemizationsByType,
        selectedType,
        noRefundSelected: selectedType === '',
      };

    case SELECT_REFUND_OPTION:
      return {
        ...state,
        selectedType,
        noRefundSelected: selectedType === '',
      };

    case RECEIVE_REFUND_ELIGIBILITY:
      return {
        ...state,
        refundEligibility,
      };

    case NAVIGATION_TO_LANDING_PAGE:
    case NAVIGATION_TO_STEP_1:
    case NAVIGATION_TO_STEP_2:
      return { ...initialState };

    default:
      return state;
  }
};
